import { render, staticRenderFns, recyclableRender, components } from "./home-push.vue?vue&type=template&id=63a5374a&"
var renderjs
import script from "./home-push.vue?vue&type=script&lang=js&"
export * from "./home-push.vue?vue&type=script&lang=js&"
import style0 from "./home-push.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/index/home-push/home-push.vue"
export default component.exports